import React from 'react';

function Hero() {
  return (
    <section className="relative w-full h-screen overflow-hidden">
      
      {/* Image background */}
      <div className="absolute inset-0 bg-[#0e1e52]">
        <img
          src="/image/bg-hero-2.jpg"
          alt="Hero background"
          className="w-full h-full object-cover opacity-50"
        />
        {/* Dark overlay */}
        <div className="absolute inset-0 bg-black/60" />
        {/* Subtle gradient for depth */}
        <div className="absolute inset-0 bg-gradient-to-t from-[#0e1e52] via-transparent to-transparent" />
      </div>

      {/* Content overlay */}
      <div className="relative z-10 flex flex-col items-center justify-center h-full text-center px-6">

        {/* Small top mark */}
        <span className="w-14 h-[2px] bg-[#ce381b] mb-8" />

        {/* Headline — stacked lines */}
        <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white leading-tight max-w-3xl">
          <span className="text-[#ce381b]">Expert</span> Advice
          <br />
          <span className="text-[#ce381b]">Trusted</span> Support
          <br />
          <span className="text-[#ce381b]">Professional</span> Services
        </h1>

        {/* Subtext */}
        <p className="text-white/80 text-base sm:text-lg leading-relaxed max-w-xl mt-6">
          Redoura helps you stay ready for it with coverage built around your business or your life, not a generic policy.
        </p>

        {/* Bottom anchor line */}
        <div className="w-10 h-[2px] bg-white/20 mt-8" />

      </div>

      {/* Scroll indicator */}
      {/* <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-10">
        <div className="w-6 h-10 border-2 border-white/40 rounded-full flex justify-center pt-2">
          <div className="w-1 h-3 bg-white/60 rounded-full animate-bounce" />
        </div>
      </div> */}

    </section>
  );
}

export default Hero;